let Hooks = {}

Hooks.JSONTextArea = {
    mounted() {
        this.formatJson();
        this.el.addEventListener("blur", () => {
            this.formatJson()
        })
    },

    formatJson() {
        try {
            const parsedJson = JSON.parse(this.el.value);
            this.el.value = JSON.stringify(parsedJson, null, 2);
        } catch (e) {
        }
    }
};

export {Hooks}